/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SubscriptionUserControllerApplyPackagePremiumMutationResponse,
  SubscriptionUserControllerApplyPackagePremiumPathParams,
  SubscriptionUserControllerApplyPackagePremium401,
  SubscriptionUserControllerApplyPackagePremium402,
} from '../types/SubscriptionUserControllerApplyPackagePremium.ts';

function getSubscriptionUserApplyPackagePremiumUrl(
  productId: SubscriptionUserControllerApplyPackagePremiumPathParams['productId'],
) {
  const res = { method: 'POST', url: `/api/user/telegram/subscriptions/package/premium/${productId}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/subscriptions/package/premium/:productId}
 */
export async function subscriptionUserApplyPackagePremium(
  productId: SubscriptionUserControllerApplyPackagePremiumPathParams['productId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SubscriptionUserControllerApplyPackagePremiumMutationResponse,
    ResponseErrorConfig<
      SubscriptionUserControllerApplyPackagePremium401 | SubscriptionUserControllerApplyPackagePremium402
    >,
    unknown
  >({ method: 'POST', url: getSubscriptionUserApplyPackagePremiumUrl(productId).url.toString(), ...requestConfig });
  return res.data;
}
